export enum UsedTranzauraValue {
    Yes = 'Yes',
    No = 'No',
    NoDevice = 'NoDevice',
}

export enum BusAuthorizedStatus {
    SubstitutionRequired = 'SubstitutionRequired',
    BusAuthorized = 'BusAuthorized',
}

export interface MechanicalInformationRequestBody {
    id: string
    tranzauraUsageType?: UsedTranzauraValue
    timeEngineeringContactedDetails?: string
    engineeringStatement?: string
    busAuthorizedStatus?: BusAuthorizedStatus
    timeCleared?: string
    substitutionTime?: string
    subbedBonnetNumber?: string
    logId: string
}

export interface IMechanicalInformation {
    tranzauraUsageType?: UsedTranzauraValue
    timeEngineeringContactedDetails: string
    engineeringStatement: string
    busAuthorizedStatus?: BusAuthorizedStatus
    subbedBonnetNumber: string
    timeCleared: string
    substitutionTime: string
    id: string
    version: string
    userShiftId: string
    logId: string
}
